import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useNames, useStream } from "./IA";
import { useApi } from "./useApi";

const Msg = ({ m, names }) => (
  <div style={{ margin: "10px 0", display: "flex", justifyContent: m.role === "user" ? "flex-end" : "flex-start" }}>
    <div className="pre" style={{ maxWidth: "85%", padding: "10px 14px", borderRadius: 16, background: m.role === "user" ? "var(--blue)" : "#1E4F87", color: "#fff" }} data-testid={`ia-msg-${m.role}`}>
      {m.role === "user" ? m.content : names(m.content)}
    </div>
  </div>
);

const SUG = ["¿Qué habilidades se han trabajado más en boxeo?", "Resume los diarios de campo del último periodo", "¿Qué atletas en atención prioritaria no tienen seguimiento?"];

export const AsistenteView = ({ F }) => {
  const { data: convs, setData: setConvs } = useApi("/ia/conversaciones");
  const [cid, setCid] = useState("");
  const [msgs, setMsgs] = useState([]);
  const [q, setQ] = useState("");
  const { text, busy, run } = useStream();
  const names = useNames();
  const end = useRef(null);

  useEffect(() => { end.current?.scrollIntoView({ block: "nearest" }); }, [msgs, text]);

  const open = async (id) => {
    try { const { data } = await api.get(`/ia/conversaciones/${id}`); setCid(id); setMsgs(data.mensajes); } catch (e) { toast.error(errMsg(e)); }
  };
  const nueva = () => { setCid(""); setMsgs([]); };
  const borrar = async (id) => {
    if (!window.confirm("¿Borrar esta conversación?")) return;
    await api.delete(`/ia/conversaciones/${id}`).catch(() => {});
    setConvs((convs || []).filter((c) => c.id !== id));
    if (id === cid) nueva();
  };
  const send = async (e, preset) => {
    e?.preventDefault();
    const m = (preset || q).trim();
    if (!m || busy) return;
    setQ("");
    setMsgs((x) => [...x, { role: "user", content: m }]);
    const r = await run("/ia/chat", { conversacionId: cid, mensaje: m, deporte: F.deporte, periodo: F.periodo });
    if (!r) { setMsgs((x) => x.slice(0, -1)); setQ(m); return; }
    setMsgs((x) => [...x, { role: "assistant", content: r.text }]);
    if (!cid && r.conversacion) {
      setCid(r.conversacion);
      setConvs([{ id: r.conversacion, titulo: m.slice(0, 70) }, ...(convs || [])]);
    }
  };

  return (
    <div className="iagrid" data-testid="asistente-view">
      <div className="panel">
        <button className="btn btn-sol" style={{ width: "100%", minHeight: 42 }} onClick={nueva} data-testid="ia-nueva-btn">Nueva conversación</button>
        <div style={{ marginTop: 10 }}>
          {(convs || []).map((c) => (
            <div key={c.id} style={{ display: "flex", gap: 6, alignItems: "center", marginBottom: 6 }}>
              <button className="chip" aria-pressed={c.id === cid} style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} onClick={() => open(c.id)} data-testid={`ia-conv-${c.id}`}>{c.titulo}</button>
              <button className="chip" aria-label="Borrar" onClick={() => borrar(c.id)} data-testid={`ia-conv-del-${c.id}`}>✕</button>
            </div>
          ))}
          {convs && !convs.length && <p className="note">Sin conversaciones aún.</p>}
        </div>
      </div>
      <div className="panel" style={{ display: "flex", flexDirection: "column", minHeight: 420 }}>
        <b>Asistente IA del equipo</b>
        <p className="note" style={{ margin: "4px 0 0" }}>Responde con base en los registros y el panel ({F.deporte || "todos los deportes"} · {F.periodo || "todos los periodos"}). A Claude se le envían los atletas con código, no con su nombre. No reemplaza tu criterio profesional.</p>
        <div style={{ flex: 1, overflowY: "auto", maxHeight: 520, margin: "10px 0" }} data-testid="ia-mensajes">
          {!msgs.length && !busy && <div className="chips">{SUG.map((s) => <button key={s} className="chip" onClick={() => send(null, s)} data-testid="ia-sugerencia">{s}</button>)}</div>}
          {msgs.map((m, i) => <Msg key={i} m={m} names={names} />)}
          {busy && <Msg m={{ role: "assistant", content: text || "Pensando…" }} names={names} />}
          <div ref={end} />
        </div>
        <form onSubmit={send} style={{ display: "flex", gap: 8 }}>
          <input value={q} onChange={(e) => setQ(e.target.value)} maxLength={2000} placeholder="Pregunta sobre registros, sesiones o atletas…" data-testid="ia-input" />
          <button className="btn btn-sol" type="submit" disabled={busy || !q.trim()} data-testid="ia-send-btn">Enviar</button>
        </form>
      </div>
    </div>
  );
};
